module.exports = __webpack_public_path__ + "static/img/representative.04d9a60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/representative.png
// module id = b+mv
// module chunks = 1